module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content border radius-10 mb-50"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "bg-gary p-10 skillListTitle"
  }, [_c('h2', [_vm._v("Extended Project Qualification")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": require('../../assets/epq_forms1-13.docx')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" EPQ offline document")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, _vm._l((_vm.report.skillList), function(skill) {
    return (skill.pageList.length !== 0 && (skill.name !== 'Form 12' && skill.name !== 'Form 10')) ? _c('el-row', {
      key: skill.id,
      staticClass: "border-b-2 p-20 ml-none mr-none",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      staticClass: "mt-10 mb-20",
      attrs: {
        "span": 6
      }
    }, [_c('div', [_c('h2', {
      staticClass: "mb-2"
    }, [_vm._v(_vm._s(skill.name))])])]), _vm._v(" "), _c('el-col', {
      staticClass: "line-right",
      attrs: {
        "span": 18
      }
    }, _vm._l((skill.pageList), function(page) {
      return _c('div', {
        key: page.id,
        staticClass: "el-col-8"
      }, [(skill.name !== 'Form 13') ? _c('div', {
        staticClass: "border-b"
      }, [_c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.showPageDialog(skill, page)
          }
        }
      }, [_vm._v(_vm._s(page.page))])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
        staticClass: "white mt-20",
        staticStyle: {
          "display": "inline-block",
          "vertical-align": "super"
        },
        attrs: {
          "to": {
            path: 'evidence',
            query: {
              studentId: _vm.studentId,
              pageId: page.id,
              skillAbbr: skill.abbr,
              skillName: skill.name,
              pageName: page.page,
              reportId: _vm.report.id,
              reportName: _vm.report.category,
              reportIndex: _vm.$route.path
            }
          },
          "append": ""
        }
      }, [_c('el-tooltip', {
        attrs: {
          "effect": "dark",
          "content": "Evidence",
          "placement": "top"
        }
      }, [(_vm.category === 'epq' && page.showUpload == true) ? _c('el-button', {
        attrs: {
          "type": "primary",
          "size": "mini",
          "plain": ""
        }
      }, [_vm._v(_vm._s(skill.name == 'Form 11' ? 'Result Download' : 'Submission Entry')), _c('i', {
        staticClass: "icon ion-folder ml-10"
      })]) : _vm._e()], 1)], 1)], 1)
    }), 0)], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "report": _vm.report
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "generate-link"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b608816"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/student/Report.vue
// module id = 603
// module chunks = 1